import React from 'react';
import { Spinner } from 'react-bootstrap';
import '../styles/loadingSpinner.css';

const LoadingSpinner = () => (
  <div className="loading-overlay">
    <Spinner animation="grow" variant="primary" size="lg" />
  </div>
);

export default LoadingSpinner;
